import { Component, ViewChild } from '@angular/core';
import { CrudPatientComponent } from '../crud-patient/crud-patient.component';
import { COMMON_IMPORTS } from '../../global-misc/common-imports';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { PatientsViewComponent } from '../patients-view/patients-view.component';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-manage-patients',
  standalone: true,
  imports: [...COMMON_IMPORTS, CrudPatientComponent, DialogModule, ButtonModule, PatientsViewComponent],
  templateUrl: './manage-patients.component.html',
})
export class ManagePatientsComponent {
  @ViewChild(PatientsViewComponent) patientsView!: PatientsViewComponent;
  @ViewChild(CrudPatientComponent) crudPatientComponent!: CrudPatientComponent;

  public showAddPatientDialog: boolean = false;
  public orgId: string;

  constructor(private readonly router: ActivatedRoute) {
    this.orgId = this.router.snapshot.paramMap.get('orgId') as string;
  }

  public openAddPatientDialog() {
    this.showAddPatientDialog = true;
  }

  public closeAddPatientDialog() {
    this.showAddPatientDialog = false;
  }

  public onPatientAdded(): void {
    this.closeAddPatientDialog();
    this.patientsView.reload();
  }
}
